module.exports = __webpack_public_path__ + "static/media/c31.0d102fc3.png";